import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database-deprecated';

import { OrderedJoinServiceBase } from '../../shared/base/ordered-join-service-base';

@Injectable()
export class CourseLectureService extends OrderedJoinServiceBase {
  constructor(db: AngularFireDatabase) {
    super(db, '/course-lectures', '/lectures');
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/shared/course-lecture.service.ts